import Store from 'store/store';
import cached from 'utils/cached';
import { api } from 'utils/bolt/api';
import { asList, commaSeparatedList } from 'utils/utils';
import { getShowtimesData } from 'utils/bolt';
import hooks from 'utils/hooks';

// Not waiting, we just want whatever is available
const currentLocationOptions = async () => {
	// Should we use geo from ip or the current location?
	// let geo = accessNested(Store.get(), 'client.geo') || {};
	// return { lat: geo.lat, lon: geo.lon };
	try {
		const geo = await geoFromIP();
		return { lat: geo.lat, lon: geo.lon };
	} catch (err) {
		return {};
	}
};

const defaultLanguageOptions = () => {
	const lang = Store.get().appData?.meta?.region?.language;
	return lang ? { lang } : {};
};

// const getDefaultRegionBiasing = cached(() => {
// 	// let region = (await geoFromIP()).countryCode;
// 	let region = __REGION__;
// 	// Special cases (ccTLD, not ISO ; see https://developers.google.com/maps/documentation/geocoding/intro#RegionCodes)
// 	if (region === 'gb') {
// 		region = 'uk';
// 	}
// 	if (!/^[a-z]{2}$/.test(region)) {
// 		return;
// 	}
// 	return { region };
// });

export const geoFromIP = cached(async () => {
	let data = {};
	try {
		let result = await fetch('https://stdata.powster.com/geo');
		data = await result.json();
	} catch (err) {}
	if (!data?.city) {
		try {
			let countryCode = data?.countryCode || __REGION__;
			let capitalURL = new URL('https://stdata.powster.com/capital');
			capitalURL.searchParams.set('country', countryCode.toLowerCase());
			let capitalRes = await fetch(capitalURL);
			if (!capitalRes.ok) throw new Error();
			Object.assign(data, await capitalRes.json());
		} catch (err) {}
	}
	if (data?.countryCode) {
		data.countryCode = data.countryCode.toLowerCase();
	}
	return data;
});

export async function geoSearch(options) {
	const showtimesData = getShowtimesData();
	const allAllowedRegions = [__REGION__, ...asList(showtimesData.boundingRegions)].map(s => s.toUpperCase());

	options = Object.assign(
		{},
		await currentLocationOptions(),
		defaultLanguageOptions(),
		options
	);
	if (!options.search) {
		throw new Error('Searching with empty value');
	}

	const data = await api('/geo/search', options);
	if (!data?.response) {
		throw new Error('Unable to search for ' + options.search);
	}

	const hiddenCountryNames = Object.fromEntries(
		Object.entries(showtimesData.hiddenCountryNames || {}).map(([code, namesRaw]) => {
			if (namesRaw == null) return null;
			let names = commaSeparatedList(namesRaw);
			if (typeof RegExp.escape === 'function') names = names.map(RegExp.escape);
			return [
				code.toUpperCase(),
				!namesRaw.length ? true : new RegExp(`(,\\s*)?\\b(${names.join('|')})\\b`, 'gi'),
			];
		}).filter(Boolean)
	);

	const response = data.response.filter(r => {
		const hiddenDetails = hiddenCountryNames[r.countryCode];
		if (!hiddenDetails) return true;
		if (r.labelType === 'country') return false;
		if (hiddenDetails instanceof RegExp) {
			r.label = r.label.replace(hiddenDetails, '');
		}
		return true;
	}).sort((a, b) => {
		let aAllowed = allAllowedRegions.includes(a.countryCode);
		let bAllowed = allAllowedRegions.includes(b.countryCode);
		// Things included in bounding regions should show up first in results
		return aAllowed === bAllowed ? 0 : (aAllowed ? -1 : 1);
	});

	return await hooks.call('geo.search.response', response);
}
export async function geoSearchOne(options) {
	let res = await geoSearch(options);
	if (!res?.[0]) {
		throw new Error('No results for ' + options.search);
	}
	return res[0];
}